import Routes from '../Routes';
import React from 'react';
import connectionStatus, {NOT_AUTHORIZED, SERVER_REACHABLE} from '../../connectionStatus';
import axios from 'axios';
import {API_ENDPOINT} from '../../util/constants';
import {useAuth} from '../../util/authContext';
import {setRedirectReason} from '../Page';
import { SyncEngine } from '../../db';

axios.defaults.timeout = 25000; // 25 seconds
axios.defaults.withCredentials = true;
console.log("API ENDPOINT: " + API_ENDPOINT);
axios.defaults.baseURL = API_ENDPOINT;

export default () => {
    const { removeSession } = useAuth();
    React.useEffect(() => {

        //console.log("Running Root useEffect...");

        axios.interceptors.response.use(
            function (response) {
                return response;
            },
            function (error) {
                if (error.message.indexOf("timeout of") >= 0) {
                    // Tell connection status that the connection is not reliable.
                    console.log('Network request timed out: ', error);
                    connectionStatus.networkError();
                    return Promise.reject(error);
                } else if (error.message.indexOf("Network Error") >= 0) {
                    console.log('Network request failed: ', error);
                    connectionStatus.networkError();
                    return Promise.reject(error);
                } else if (error.response && error.response.status === 401) {
                    if (window.location.pathname !== "/signin") {
                        console.log("Received 401 (unauthorized), navigating to /signin.");
                        removeSession();
                        setRedirectReason('session_expired');
                        window.location = '/signin';
                    }
                } else if (error.response && error.response.status === 402) {
                    // 402 means "authenticated but not subscribed" - not "session invalid".
                    // Unlike 401, we must NOT removeSession() here: a background call (e.g.
                    // the pending-data sync fired on every login) can 402 while the user is
                    // sitting on /account or /subscribe trying to pay, and wiping their
                    // session out from under them turns that into an unbreakable
                    // signin <-> expired loop, since checkout itself requires being signed in.
                    const alreadyOnAllowedPage = ["/account", "/subscribe", "/expired"]
                        .includes(window.location.pathname);
                    if (!alreadyOnAllowedPage) {
                        console.log("Received 402 (expired), navigating to /expired.");
                        setRedirectReason('account_expired');
                        window.location = '/expired';
                    } else {
                        console.log("Received 402 (expired) while already on an account/checkout page; not redirecting.");
                    }
                    return Promise.reject(error);
                } else {
                    return Promise.reject(error);
                }
            },
        );

        const onServerReachable = () => {
            // SyncEngine handles pending data sync (replaces legacy Redux sendPendingData)
            SyncEngine.processPendingQueue();
        };

        const onNotAuthorized = () => {
            if (window.location.pathname === "/" || window.location.pathname.indexOf("/case/") >= 0) {
                console.log("Not authorized event from connectionStatus. Going to sign in page.");
                removeSession();
                window.location = '/signin';
            }
        }

        connectionStatus.on(SERVER_REACHABLE, onServerReachable);
        connectionStatus.on(NOT_AUTHORIZED, onNotAuthorized);

        if (connectionStatus.isServerReachable()) {
            connectionStatus.emit(SERVER_REACHABLE);
        }

        if (!connectionStatus.authorized) {
            onNotAuthorized();
        }

        return () => {
            //console.log("Tearing down root useEffect...");
            connectionStatus.removeListener(SERVER_REACHABLE, onServerReachable);
        };
    }, [removeSession]);

    return (
        <Routes/>
    )
};
